import type { FC } from 'react';
import { FormContainer } from 'components/layout';
import {
  CreativesColumn,
  PreviewLayout,
  TemplatesColumn,
} from './LaunchPreview.styles';
import CreativesPreview from './ScalingCreativesPreview';
import TemplatesPreview from './TemplatesPreview';

const LaunchPreviewForm: FC = () => (
  <FormContainer title="Launch preview">
    <PreviewLayout>
      <CreativesColumn>
        <CreativesPreview />
      </CreativesColumn>
      <TemplatesColumn>
        <TemplatesPreview />
      </TemplatesColumn>
    </PreviewLayout>
  </FormContainer>
);

export default LaunchPreviewForm;
